import Logout from "@mui/icons-material/Logout";
import Settings from "@mui/icons-material/Settings";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import { useQuery } from "@tanstack/react-query";
import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import type { ClienteEsterno } from "../../../models/restAPI";
import { publicApiEndpoint } from "../config";
import { useUserContext } from "../context/UserContext";
import { fetchJson } from "../services/api";
import { useUserAttributes } from "../services/user-manager.service";

export default function AccountMenu() {
  /* Recupero le informazioni del profilo dell'utente */
  const { user, isLoading, selectedCliente } = useUserContext();
  const profile = useUserAttributes();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    navigate("/logout");
  };
  const { data: clienteEsterno } = useQuery({
    enabled: !isLoading && user?.Kind === "Customer",
    queryKey: ["cliente-esterno"],
    queryFn: () =>
      fetchJson<ClienteEsterno>(
        `${publicApiEndpoint}/cliente/usalesman${user?.Kind === "Agent" ? "?customer_id=" + selectedCliente?.id : ""}`,
      ),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
  });
  return (
    <Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            sx={{
              color: "inherit",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            <button className="account-info-button">
              <div>
                <span>{profile?.name}</span>
              </div>
              <div>
                <span>
                  {/* Prendi le prime iniziali delle due parole o in alternativa la prima lettera */}
                  {(
                    clienteEsterno?.TradeName.split(" ")
                      .map((word) => word.charAt(0))
                      .join("") || "U"
                  ).toUpperCase()}
                </span>
              </div>
            </button>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              minWidth: 180,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
        <MenuItem onClick={() => navigate("/impostazioni")}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Impostazioni
        </MenuItem>
      </Menu>
    </Fragment>
  );
}
